import React, { useState } from 'react';
import Button from '../Button/Button';
import TextInput from '../FormInputs/TextInput/TextInput';
import PasswordInput from '../FormInputs/PasswordInput/PasswordInput';
import HypertextLink from '../HypertextLink/HypertextLink';
import { navigateToDashboard } from '../../utils/navigation';
import { useToasts } from '../../hooks/useToasts';
import { login } from '../../utils/api/login';

const validateForm = (email, password) => {
  if (!email || !password) {
    return 'Email and password are required.';
  }
  return '';
};

const LoginForm = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const { showToast } = useToasts();

  const handleSubmit = async () => {
    setError('');
    const formError = validateForm(email, password);
    if (formError) {
      setError(formError);
      showToast({ message: formError, type: 'error' });
      return;
    }

    const result = await login(email, password);

    if (result.success) {
      navigateToDashboard();
    } else {
      setError(result.error);
      showToast({ message: result.error, type: 'error' });
    }
  };

  return (
    <div className="w-77 h-83.5">
      <h3 className="text-2xl font-bold text-center mb-6">Login</h3>

      <div>
        <TextInput
          label="Email"
          name="email"
          dataTestId="login-email-input"
          value={email}
          setValue={setEmail}
          placeholder="example@email.com"
          isRequired={false}
          className="h-10 pt-3.25 pb-3.25 pl-3 mb-4.75"
          labelTextSize="text-lg font-medium"
          error={error}
          spaceY="space-y-1" // Vertical spacing to 4px
          fontSize="text-sm"
        />
        <PasswordInput
          label="Password"
          id="password"
          name="password"
          dataTestId="login-password-input"
          value={password}
          setValue={setPassword}
          placeholder="password"
          isRequired={false}
          validationError={error}
          isNewPassword={false}
          extraInfo={null}
          shouldHideConfirmedIcon
          className="pt-2.75 pb-2.75 pl-3 pr-3.25"
          fontSize="text-sm"
          labelMargin="mb-1" // Vertical spacing to 4px
        />
      </div>

      <div className="flex justify-center items-center">
        <Button
          label="Login"
          type="button"
          dataTestId="login-button"
          onClick={handleSubmit}
          className="inline-flex h-9.5 min-w-20.5 mt-8.25 justify-center items-center flex-shrink-0"
          fontWeight="font-medium"
        />
      </div>

      <HypertextLink
        href="/users/password/new"
        className="mt-5.25 hover:underline block text-center underline"
        id="forgot-password"
        dataTestId="login-forgot-password-link"
      >
        Forgot password?
      </HypertextLink>
    </div>
  );
};

export default LoginForm;
